import { Goal } from '@griply/types';

import { normalizeForSearch } from './normalize-for-search';

export const filterGoalsBySearchText = (
  goals: Goal[],
  searchText: string,
): Goal[] => {
  if (!searchText) {
    return [];
  }
  const normalizedSearchText = normalizeForSearch(searchText.trim());

  return goals
    .filter(({ name }) =>
      normalizeForSearch(name).includes(normalizedSearchText),
    )
    .sort((a, b) => a.name.localeCompare(b.name));
};
